import api from './client';

const BASE = '/notepad';

// ── Dashboard ──
export const getNotepadDashboard = () => api.get(`${BASE}/dashboard`);

// ── Notes ──
export const listNotes = (params = {}) => api.get(`${BASE}/notes`, { params });
export const getNote = (id) => api.get(`${BASE}/notes/${id}`);
export const createNote = (data) => api.post(`${BASE}/notes`, data);
export const updateNote = (id, data) => api.put(`${BASE}/notes/${id}`, data);
export const toggleFavorite = (id) => api.patch(`${BASE}/notes/${id}/favorite`);
export const deleteNote = (id) => api.delete(`${BASE}/notes/${id}`);
export const restoreNote = (id) => api.post(`${BASE}/notes/${id}/restore`);
export const permanentDeleteNote = (id) => api.delete(`${BASE}/notes/${id}/permanent`);

// ── Public Links ──
export const createPublicLink = (id, settings = {}) => api.post(`${BASE}/notes/${id}/public-link`, settings);
export const updatePublicLinkSettings = (id, settings) => api.put(`${BASE}/notes/${id}/public-link`, settings);
export const revokePublicLink = (id) => api.delete(`${BASE}/notes/${id}/public-link`);

// ── Shares ──
export const getNoteShares = (id) => api.get(`${BASE}/notes/${id}/shares`);
export const shareNote = (id, data) => api.post(`${BASE}/notes/${id}/shares`, data);
export const revokeShare = (noteId, shareId) => api.delete(`${BASE}/notes/${noteId}/shares/${shareId}`);

// ── Activity ──
export const getNoteActivity = (id) => api.get(`${BASE}/notes/${id}/activity`);

// ── Categories ──
export const getNotepadCategories = () => api.get(`${BASE}/categories`);
export const createNotepadCategory = (data) => api.post(`${BASE}/categories`, data);
export const deleteNotepadCategory = (id) => api.delete(`${BASE}/categories/${id}`);

// ── Tags ──
export const getNotepadTags = () => api.get(`${BASE}/tags`);
export const createNotepadTag = (data) => api.post(`${BASE}/tags`, data);

// ── Templates ──
export const getNotepadTemplates = () => api.get(`${BASE}/templates`);
export const createNotepadTemplate = (data) => api.post(`${BASE}/templates`, data);
export const deleteNotepadTemplate = (id) => api.delete(`${BASE}/templates/${id}`);

// ── Public Note (no auth header needed — raw axios fetch) ──
export const fetchPublicNote = (token) => api.get(`/n/${token}`);
export const updatePublicNote = (token, data) => api.put(`/n/${token}`, data);
